'use client'

import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Button from '@/components/CommonComponent/button'
import { useRouter } from 'next/navigation'
import Image from 'next/image'
import Link from 'next/link'

const truncateText = (text: string, limit: number) =>
    text.length > limit ? text.slice(0, limit) + '...' : text

const Card = ({ elem, index, activeTab }: { elem: any, index: number, activeTab: 'blogs' | 'news' }) => {
    const Router = useRouter()

    return (
        <motion.div
            key={elem?.slug_link}
            layout
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="relative border-[2px] border-lightblue hover:shadow-xl duration-300 w-[461px] pb-2 rounded-lg"
        >
            <div className="bg-pinkdarker absolute top-3 left-3 text-white text-[17px] font-medium rounded-lg py-1 px-4">
                {elem?.blog_date ? (() => {
                    const date = new Date(elem.blog_date)
                    const day = String(date.getDate()).padStart(2, '0')
                    const month = date.toLocaleString('en-US', { month: 'short' })
                    const year = date.getFullYear()
                    return `${day} ${month}, ${year}`
                })() : ''}
            </div>

            <div className="text-bluedarker font-medium px-3 py-1 w-fit absolute top-3 right-3 rounded-md bg-white shadow-lg">
                <Link
                    href={
                        activeTab === 'blogs'
                        ? `/blog/${elem?.category?.category_slug}`
                        : `/news/${elem?.category?.category_slug || ''}`
                    }
                >
                    <span>{elem?.category?.name || 'Uncategorized'}</span>
                </Link>
            </div>

            <div>
                {elem?.image && (
                    <Image
                        src={elem.image}
                        alt={elem?.image_alt || elem?.title}
                        height={218}
                        width={461}
                        className="rounded-lg w-auto max-h-[218px]"
                        unoptimized
                    />
                )}
            </div>

            <div className="p-4 flex flex-col gap-3 justify-between">
                <p className="font-bold text-center sm:text-left text-homeblack text-[20px] 2xl:text-[24px] leading-tight cursor-pointer">
                    <Link
                        href={
                            activeTab === 'blogs'
                            ? `/blog/${elem?.category?.category_slug}/${elem?.slug_link}`
                            : `/news/${elem?.category?.category_slug}/${elem?.slug_link}`
                        }
                    >
                        {truncateText(elem?.title, 30)}
                    </Link>
                </p>

                <p className="text-homegrey text-center sm:text-left leading-[21px] text-[16px] xl:text-[18px]">
                    {truncateText(elem?.summary, 60)}
                </p>

                <div className="flex justify-center sm:justify-start">
                    <div className="w-fit">
                         <Link
                        href={
                            activeTab === 'blogs'
                            ? `/blog/${elem?.category?.category_slug}/${elem?.slug_link}`
                            : `/news/${elem?.category?.category_slug}/${elem?.slug_link}`
                        }
                    >
                        <Button content="View" />
                        </Link>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default function BlogNewsTabs({ blogs = [], news = [] }: { blogs: any[]; news: any[] }) {
    const [activeTab, setActiveTab] = useState<'blogs' | 'news'>('blogs')
    const [blogHead, setblogHead] = useState({ first: '', second: '' })
    const [newsHead, setnewsHead] = useState({ first: '', second: '' })
    function splitStringByLastWords(text: string, numOfWords: number) {
        const words = text.split(' ')
        if (numOfWords >= words.length) {
            return { first: '', second: text }
        }
        const splitIndex = words.length - numOfWords
        const firstPart = words.slice(0, splitIndex).join(' ')
        const secondPart = words.slice(splitIndex).join(' ')
        return { first: firstPart, second: secondPart }
    }
    // Truncate text by a specific character limit
    function truncateText(text: string, limit: number) {
        if (text.length > limit) {
            return text.substring(0, limit) + '...'
        }
        return text
    }
    useEffect(() => {
        const result = splitStringByLastWords('Latest Blog Posts & Industry Insights', 2)
        const result2 = splitStringByLastWords('Digital Marketing News & Trends', 3)
        setblogHead(result)
        setnewsHead(result2)
    }, [])

    return (
        <div className="w-full px-4 mx-auto py-10 lg:py-16 xl:w-[95%] 2xl:w-[80%]">
            <div className="flex justify-center gap-6 mb-7">
                <button
                    onClick={() => setActiveTab('blogs')}
                    className={`xl:px-8 lg:px-5 px-2  py-2 rounded-md text-lg font-semibold border transition-all ${activeTab === 'blogs'
                        ? 'bg-pink text-white border-pink shadow-lg'
                        : 'bg-white border-homegrey text-homegrey hover:bg-pink hover:text-white'
                        }`}
                >
                    Blogs
                </button>
                <button
                    onClick={() => setActiveTab('news')}
                    className={`xl:px-8 lg:px-5 px-2  py-2 rounded-md text-lg font-semibold border transition-all ${activeTab === 'news'
                        ? 'bg-pink text-white border-pink shadow-lg'
                        : 'bg-white border-homegrey text-homegrey hover:bg-pink hover:text-white'
                        }`}
                >
                    News
                </button>
            </div>
            {activeTab === "blogs" &&
                <>
                    <h2 className="  text-homeblack font-bold text-center my-4">
                        {blogHead?.first} <span className="text-pink">{blogHead?.second}</span>
                    </h2>
                    <p className="text-homegrey text-[16px] lg:text-[18px] text-center">
                        Stay ahead of Search marketing trends with expert blogs, case studies, and in-depth guides on SEO, PPC, content marketing, and more.
                    </p></>
            }
            {activeTab === "news" &&
                <>
                    <h2 className="  text-homeblack font-bold text-center my-4">
                        {newsHead?.first} <span className="text-pink">{newsHead?.second}</span>
                    </h2>
                    <p className="text-homegrey text-[16px] lg:text-[18px] text-center">
                        Stay updated with industry movements, and actionable news covering SEO, PPC, content strategy, emerging platforms, and marketing innovation.
                    </p></>
            }

            <AnimatePresence mode="wait">
                <motion.div
                    key={activeTab}
                    layout
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="flex justify-center flex-wrap lg:flex-nowrap gap-7 mt-7"
                >
                    {(activeTab === 'blogs' ? blogs : news).slice(0, 3).map((item, i) => (
                        <Card key={i} elem={item} index={i}  activeTab={activeTab} />
                    ))}
                </motion.div>
            </AnimatePresence>

            <div className="w-full mt-10 flex justify-center items-center">
                <div className="w-fit">
                    <Link href={activeTab === 'blogs' ? '/blog' : '/news'}>
                    <Button content={`View All ${activeTab === 'blogs' ? 'Blogs' : 'News'}`} />
                    </Link>
                </div>
                </div>
            </div>
    )
}
